module.exports = __webpack_public_path__ + "static/media/topthumbnail@2x.0cd3d817.png";